var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_4714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0491 0.792419H1.95242C1.33257 0.792419 0.830078 1.27207 0.830078 1.86375V19.1379C0.830078 19.7296 1.33257 20.2092 1.95242 20.2092H20.0491C20.669 20.2092 21.1715 19.7296 21.1715 19.1379V1.86375C21.1715 1.27207 20.669 0.792419 20.0491 0.792419Z",
    fill: "#3D5A98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8636 20.2076V12.6886H17.5071L17.9024 9.75843H14.8636V7.88812C14.8636 7.03991 15.1111 6.46077 16.3847 6.46077H18.0107V3.83577C17.2233 3.75759 16.4321 3.72035 15.6405 3.72421C13.2996 3.72421 11.6874 5.08593 11.6874 7.59773V9.75843H9.04395V12.6886H11.6874V20.2076H14.8636Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_4714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.df62849a33711891902cb186a757d937.svg";
export { ForwardRef as ReactComponent };